@if (viewers().length > 0) {
  <div class="viewers-avatars" nz-tooltip [nzTooltipTitle]="tooltipTitle">
    <span class="viewers-avatars__label">
      {{ tooltipTranslationKey() | translate }}
    </span>

    @for (viewer of visibleViewers(); track $index) {
      @if (viewer | isNonAccessibleViewer) {
        <wilson-user-avatar
          class="viewers-avatars__avatar"
          [s3Urn]="null"
        ></wilson-user-avatar>
      } @else {
        <wilson-user-avatar
          class="viewers-avatars__avatar"
          [s3Urn]="viewer.profileImageUrl"
          [userInitials]="getViewerInitials(viewer)"
          [iconColor]="getViewerColor(viewer)"
        ></wilson-user-avatar>
      }
    }

    @if (overflowCount() > 0) {
      <span class="viewers-avatars__overflow">+{{ overflowCount() }}</span>
    }
  </div>

  <ng-template #tooltipTitle>
    {{ 'page.shift_timeline.presence.currently_online_tooltip' | translate }}
    {{ viewerNames() }}
  </ng-template>
}
